var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticStyle:{"margin":"20px"}},[_vm._v(" You can add new support requests by clicking on ADD ITEM, and view the status of existing support requests in the table below. ")]),_c('server-table-component',{attrs:{"table":"sys_supportreq","schema":"sch_sys_supportreq"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }